import { Component, Input } from "@angular/core";

import { InputBoolean } from "ng-zorro-antd/core/util";
import { ɵNzSliderMarksComponent as NzSliderMarksComponent } from "ng-zorro-antd/slider";
import { UiExtendedMark } from "@webapp/ui/slider/models/slider.models";

@Component({
  selector: "ui-slider-marks",
  exportAs: "uiSliderMarks",
  templateUrl: "marks.component.html",
})
export class UiSliderMarksComponent extends NzSliderMarksComponent {
  @Input("uiLowerBound")
  public lowerBound: number | null = null;
  @Input("uiUpperBound")
  public upperBound: number | null = null;
  @Input("uiMarksArray")
  public marksArray: UiExtendedMark[] = [];
  @Input("uiMin")
  public min!: number;
  @Input("uiMax")
  public max!: number;
  @Input("uiVertical")
  @InputBoolean()
  public vertical = false;
  @Input("uiIncluded")
  @InputBoolean()
  public included = false;
  @Input("uiReverse")
  public reverse!: boolean;
}
